import React, { useState, Fragment } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import { DialogActions, Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import MaxFourNumber from "Components/Input/components/MaxFourNumber";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import { addMahdoode, changeMahdoodeSearch, getMahdoode } from "Stores/actions";
import showNotify from "Helpers/Notify";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";

function NewMahdoode() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    isWidth,
    isHeight,
    selectedBazsho,
    selectedBrandYaragh,
    mahdoodeDataPagination,
  } = useSelector((state) => ({
    isWidth: state.yaragh.isWidth,
    isHeight: state.yaragh.isHeight,
    selectedBazsho: state.yaragh.selectedBazsho,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
    mahdoodeDataPagination: state.yaragh.mahdoodeDataPagination,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    mahdoodeName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    priceMahdoode: {
      type: "price",
      value: "0",
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    minW: {
      type: "millimeter",
      value: "0",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    maxW: {
      type: "millimeter",
      value: "0",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
        notZero: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    minH: {
      type: "millimeter",
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    maxH: {
      type: "millimeter",
      value: "0",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
        notZero: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = (isOnClose = false) => {
    if (isOnClose) onClear();
    setOpenDialog(!openDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { mahdoodeName, priceMahdoode, minH, maxH, minW, maxW } = controls;
      if (
        (isWidth && +minW.value >= +maxW.value) ||
        (isHeight && +minH.value >= +maxH.value)
      ) {
        showNotify({
          text: t("minBTmax"),
          customClass: "error",
        });
      } else {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdPop: +selectedBazsho.Id,
            Name: mahdoodeName.value,
            MinWidth: minW.value,
            MaxWidth: maxW.value,
            MinHeight: minH.value,
            Maxheight: maxH.value,
            Id: +selectedBrandYaragh.Id,
            Price: +priceMahdoode.value,
          };
          if (await dispatch(addMahdoode(data))) {
            handleDialog();
            dispatch(changeMahdoodeSearch({ Name: "" }));
            const params = {
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
              IdPop: +selectedBazsho.Id,
              Limit: mahdoodeDataPagination.Limit,
              Page: mahdoodeDataPagination.Page,
            };
            await dispatch(getMahdoode(params));
          }
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const onEnter = () => onClear();

  const onClear = () => {
    setCheckValid(false);
    setFormValid({
      mahdoodeName: false,
      priceMahdoode: false,
      maxH: !isHeight,
      maxW: !isWidth,
    });
    setControls({ mahdoodeName: { value: "" } });
    setControls({ priceMahdoode: { value: "0" } });
    setControls({ minH: { value: "0" } });
    setControls({ maxH: { value: "0" } });
    setControls({ minW: { value: "0" } });
    setControls({ maxW: { value: "0" } });
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"newAccessoryRange"} />}
        onClick={handleDialog}
        disabled={selectedBrandYaragh?.Disable}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={() => handleDialog(true)}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <BackDropLoading loading={loading} />
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              {<Translator id={"addNewAccessoryRange"} />}
              {selectedBazsho && <span> ({selectedBazsho.Name})</span>}
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              {Object.keys(controls)
                .filter(
                  (key) =>
                    controls[key].type !== "millimeter" ||
                    (controls[key].type === "millimeter" &&
                      ((isHeight && key.includes("H")) ||
                        (isWidth && key.includes("W"))))
                )
                .map((key) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key}
                    >
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        value={controls[key].value}
                        placeholder={t(key)}
                        endIcon={
                          controls[key].type === "price" ? (
                            <Translator id="moneyUnit" />
                          ) : controls[key].type === "millimeter" ? (
                            <Translator id="millimeter" />
                          ) : (
                            ""
                          )
                        }
                        inputComponent={
                          controls[key].type === "millimeter" && MaxFourNumber
                        }
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                      />
                    </Grid>
                  );
                })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default NewMahdoode;
